import { render, staticRenderFns } from "./component-games-list-history.vue?vue&type=template&id=e73d45f2&scoped=true"
import script from "./component-games-list-history.vue?vue&type=script&lang=js"
export * from "./component-games-list-history.vue?vue&type=script&lang=js"
import style0 from "./component-games-list-history.vue?vue&type=style&index=0&id=e73d45f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73d45f2",
  null
  
)

export default component.exports